export default {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
  DIALOG: 'dialog',
  TIMEOUT: 5000
}
